module.exports = __webpack_public_path__ + "static/media/cplusplus.f525a103.svg";